<template>
  <div class="childrenEducationHome"
       style="background-color:#F5F7FA">
    <div class="div-color">
      <div class="active">
        <el-steps :active="active"
                  align-center>
          <el-step title="资料收集"></el-step>
          <el-step title="测算分析"></el-step>
          <el-step title="产品方案"></el-step>
          <el-step title="规划结论"></el-step>
        </el-steps>
      </div>
      <div class="btn">
        <el-button @click="previousStep"
                   v-show="active !== 0">上一步</el-button>
        <el-button type="primary"
                   @click="nextStep"
                   :disabled="disabledFlag"
                   v-if="active === 0">下一步</el-button>
        <el-button type="primary"
                   @click="nextStep"
                   :disabled="disabledFlag || getChildStepStatys"
                   v-if="active < 3 && active > 0">下一步</el-button>
        <el-button type="primary"
                   @click="complete"
                   v-if="active === 3">完成规划</el-button>
      </div>
    </div>
    <dataCollection v-if="active === 0"
                    :dialogStatus="dataCollectionDialog"
                    @toEducationReserve="getToEducationReserve"
                    @toNextStepDisabled="getToNextStepDisabled"></dataCollection>
    <Analysis v-if="active === 1"
              @toNextStepDisabled="getToNextStepDisabled"></Analysis>
    <productPlan v-if="active === 2"
                 v-on:set-disabled-flag="disabledFlag = $event"
                 v-on:regular-prd-list="regularPrdList = $event"
                 ref="productPlan"></productPlan>
    <conclusion v-if="active === 3"></conclusion>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dataCollection from './dataCollection.vue'; // 资料收集
import Analysis from './analysis.vue'; // 测算分析
import productPlan from './productPlan.vue'; // 产品方案
import conclusion from './conclusion.vue'; // 规划结论
// 规划结论
export default {
  name: 'childrenEducationHome',
  components: {
    dataCollection,
    Analysis,
    productPlan,
    conclusion,
  },
  data() {
    return {
      successCode: 'E00000',
      active: 0, // 进度
      // 默认都可以点下一步
      disabledFlag: false,
      // 常选产品列表
      regularPrdList: [],
      // 第一步教育储蓄金
      EducationReserve: {},
      dataCollectionDialog: '0',
      cust: '',
    };
  },
  computed: {
    ...mapGetters(['getChildStepStatys']),
  },
  watch: {
    disabledFlag: {
      immediate: true,
      handler(val) {
        console.log('监听是否下一步', val);
        console.log('监听是否下一步', this.getChildStepStatys);
      },
    },
  },
  created() {
    sessionStorage.setItem('custInfo', JSON.stringify(this.$route.query.row));
    sessionStorage.setItem('curCis', JSON.stringify(this.$route.query.row.cis));
    this.cust = JSON.parse(sessionStorage.getItem('custInfo'));
    console.log('created----------------', this.getChildStepStatys);
  },
  methods: {
    previousStep() {
      // 第一步页面，从列表进来传0，上一步进来传1
      this.dataCollectionDialog = '1';
      // 点击上一步，将下一步释放。
      if (this.active === 2) {
        this.disabledFlag = false;
      }
      if (this.active > 0) {
        this.active = this.active - 1;
      }
    },
    // 第四步保存快照
    complete() {
      const params = {
        data: {
          cis: this.cust.cis,
          planType: '1',
          createUserid: 1,
          measureReserveDTO: JSON.parse(sessionStorage.getItem('getMeasureReserve')),
          totalMoneyList: JSON.parse(sessionStorage.getItem('histogram')).series[3].data,
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.snapshot, params).then((res) => {
        this.$message.closeAll();
        if (res.errorCode === 'E00000') {
          this.$message.success('成功!');
          this.$router.push({
            path: '/Home',
            query: {
              userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
              userToken: JSON.parse(sessionStorage.getItem('userToken')),
              sessionData: sessionStorage.getItem('sessionData'),
            },
          });
        }
        console.log(res);
      });
    },
    // 下一步
    async nextStep() {
      if (this.active === 0) {
        const params = {
          data: {
            cis: this.cust.cis,
            currentMoney: this.EducationReserve.currentMoney,
            monthMoney: this.EducationReserve.monthMoney,
            expectedRevenue: this.EducationReserve.expectedRevenue,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        await this.nextStepFn(params);
      } else if (this.active === 2) {
        this.$refs.productPlan.saveSchemeDescription();
        // 保存常选产品
        this.saveRegularPrd();
        if (this.active < 3) {
          // eslint-disable-next-line no-plusplus
          this.active++;
        }
      } else {
        // eslint-disable-next-line no-plusplus
        this.active++;
      }
    },
    nextStepFn(params) {
      return this.$_post(this.$API.updateNextStep, params).then((res) => {
        this.$message.closeAll();
        if (res.errorCode === 'E00000') {
          this.$message.success('成功!');
          if (this.active < 3) {
            // eslint-disable-next-line no-plusplus
            this.active++;
          }
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 接受第一步教育储备金的input值
    getToEducationReserve(data) {
      // this.EducationReserve = data;
      const obj = this.deepCopy(data);
      // eslint-disable-next-line no-restricted-syntax
      for (const i in obj) {
        if (i === 'currentMoney' || i === 'monthMoney' || i === 'expectedRevenue') {
          // eslint-disable-next-line no-param-reassign
          obj[i] = obj[i].toString().replace(/,/g, '');
        }
      }
      this.EducationReserve = obj;
      console.log('父页面', this.EducationReserve.monthMoney);
    },
    // 深拷贝赋值对象
    deepCopy(obj) {
      const result = Array.isArray(obj) ? [] : {};
      // eslint-disable-next-line no-restricted-syntax
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); // 递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
    getToNextStepDisabled(data, arr, type) {
      // 判断是否可以点击下一步  type是第几步传过来的
      // this.disabledFlag = data;
      // if (!arr && this.disabledFlag) {
      //   this.disabledFlag = true;
      // }
      if (type === 1) {
        if (data) {
          if (!arr) {
            this.disabledFlag = true;
          } else {
            this.disabledFlag = true;
          }
        } else if (data === false) {
          if (arr.length === 0) {
            this.disabledFlag = true;
          } else {
            this.disabledFlag = false;
          }
        } else if (arr.length === 0) {
          this.disabledFlag = true;
        }
      } else if (type === 2) {
        if (data) {
          this.disabledFlag = true;
        } else {
          this.disabledFlag = false;
        }
      }
      // console.log('*******2222222222222*', arr);
      // console.log(!arr);
      // console.log('是否可以下一步', data);
      // console.log('是否可以下一步-arr', arr, this.getChildStepStatys);
      console.log('是否可以下一步-disabledFlag', this.disabledFlag);
    },
    // step3 保存常选产品
    saveRegularPrd() {
      const params = {
        data: {
          list: this.regularPrdList,
          planType: '1',
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.addRegularPrd, params)
        .then((res) => {
          this.$message.closeAll();
          if (res.errorCode === this.successCode) {
            this.$message.success('成功');
          }
        })
        .catch((err) => {
          console.log(err);
          this.previousStep();
        });
    },
  },
};
</script>

<style scoped>
.childrenEducationHome {
  padding: 20px 20px;
  width: 1647px;
}
.childrenEducationHome > .div-color {
  margin: 14px 0px;
  background-color: rgb(255, 255, 255);
}
.active {
  padding: 14px 0px 11px 0px;
  width: 60%;
}
.btn {
  display: flex;
  justify-content: flex-end;
  position: relative;
  right: 23px;
  bottom: 62px;
  width: 200px;
  float: right;
}
</style>
